'use es6';

import $ from 'jquery';
import { getWidgetElement as getWidgetElementOriginal, getWidgetElementImmutable as getWidgetElementImmutableOriginal } from 'ContentEditorUI/lib/inpage/getWidgetElement';
import { isEqual } from 'underscore';
import { isImmutable } from 'ContentEditorUI/utils/dataHelpers';
export function getAttributes($el) {
  const attrs = {};
  $.each($el[0].attributes, function () {
    if (this.specified) {
      attrs[this.name] = this.value;
    }
  });
  return attrs;
}
export function stringContainsHtml(str) {
  if (!str) return false;
  const testHtml = $('<div></div>').html(str).text();
  if (str === testHtml) {
    return false;
  }
  return true;
}
export const getWidgetElement = (widget, canUseGridLayoutGate) => getWidgetElementOriginal($, widget, canUseGridLayoutGate);
export const getWidgetElementImmutable = widget => getWidgetElementImmutableOriginal($, widget);
function getElementsByDataAttribute(dataAttribute, value) {
  return document.querySelectorAll(`[${dataAttribute}='${value}']`);
}
export const GLOBAL_GROUP_DATA_ATTRIBUTE = 'data-global-widget-path';
export const GLOBAL_PARTIAL_DATA_ATTRIBUTE = 'data-global-resource-path';
export const EMBED_DATA_ATTRIBUTE = 'data-embed-id';
export function getGlobalGroupElements(path) {
  return getElementsByDataAttribute(GLOBAL_GROUP_DATA_ATTRIBUTE, path);
}
export function getGlobalPartialElements(path) {
  return getElementsByDataAttribute(GLOBAL_PARTIAL_DATA_ATTRIBUTE, path);
}
export function getEmbedElements(id) {
  return getElementsByDataAttribute(EMBED_DATA_ATTRIBUTE, id);
}

// Is given string representing an empty set of p or div tags with no content?
export function isEmptyTag(str) {
  const IS_EMPTY_TAG_REGEX = /^<(div|p)[^><]*><\/(div|p)>$/i;
  return IS_EMPTY_TAG_REGEX.test(str);
}
export function isUngated(gateName, gates) {
  return gates.indexOf(gateName) > -1;
}
export function getAllInlineEditableHubDBFields(element) {
  // Just looking at the dynamic_page_hubdb_row for now before we roll
  // out support for editing arbitrary HubDB fields
  return element.querySelectorAll('[data-hs-token^="hubdb.dynamic_page_hubdb_row"]');
}
export const getDifferingKeys = (obj1, obj2) => {
  return Object.keys(obj1).reduce((result, key) => {
    if (!obj2[key]) {
      result.push(key);
    } else if (isEqual(obj1[key], obj2[key])) {
      const resultKeyIndex = result.indexOf(key);
      result.splice(resultKeyIndex, 1);
    }
    return result;
  }, Object.keys(obj2));
};
const getHasSingleInlineEditableHubDBField = widgetElementArray => {
  const widgetElement = widgetElementArray[0];
  if (!widgetElement) {
    return false;
  }
  // The `WidgetEditor` has its own focusing logic beyond what hover positions do on click.
  // If the module is in data authoring mode _and_ the a sidebar exists _and_ the field
  // is inline editable then we want to close the sidebar for inpage only editing.
  return getAllInlineEditableHubDBFields(widgetElement).length === 1;
};
export const getHasDataTokens = widget => {
  return widget.hasIn ? widget.hasIn(['body', 'data_tokens']) : Boolean(widget && widget.body && widget.body.data_tokens);
};
export const isInlineScpEditable = (widget, widgetElementArray) => {
  if (!getHasDataTokens(widget) || !getHasSingleInlineEditableHubDBField(widgetElementArray)) {
    return false;
  }
  const dataTokenPaths = isImmutable(widget) ? widget.getIn(['body', 'data_tokens']).valueSeq().toArray() : Object.values(widget.body.data_tokens);
  const inlineElement = getAllInlineEditableHubDBFields(widgetElementArray[0])[0];

  // Checks if the single data_token path is the same as the inline hubl field path
  return Boolean(dataTokenPaths.length === 1 && inlineElement && inlineElement.getAttribute('data-hs-token').split('dynamic_page_hubdb_row.')[1] === dataTokenPaths[0].split('dynamic_page_hubdb_row.')[1]);
};
export const getInsertedModulesInRichText = domNode => {
  const allModules = domNode.querySelectorAll('[data-hs-cos-type="module"]');
  return allModules;
};
export const getModuleData = event => {
  if (event.hsModuleData) {
    return event.hsModuleData;
  } else if (event.originalEvent && event.originalEvent.value && event.originalEvent.value.hsModuleData) {
    return event.originalEvent.value.hsModuleData;
  }
  return null;
};